import { Api } from "../config/request";

export default {
  driverSelectionCSVUpload() {
    return Api.get(
      "/catalyst/fleet-coach/generate_presign_urls?count=1&type=tasks"
    );
  },
  uploadCampaignAudio() {
    return Api.get(
      "/catalyst/fleet-coach/generate_presign_urls?count=1&type=tasks"
    );
  },
  createFleetCoachTask(payload) {
    return Api.post("/catalyst/fleet-coach/tasks/create", payload);
  },
  updateFleetCoachTask(payload) {
    return Api.put("/catalyst/fleet-coach/tasks/update", payload);
  },
  deleteFleetCoachTask(payload) {
    return Api.post("/catalyst/fleet-coach/tasks/delete", payload);
  },
  fetchTaskList(payload) {
    return Api.post("/catalyst/fleet-coach/tasks/list", payload);
  },
  deleteTask(payload) {
    return Api.post(`/catalyst/fleet-coach/tasks/delete-active-task`, payload);
  },
};
